<template>
	<div>

		<div @click="chooseDrag" :class="listData.undraggable?'undraggable':''" style="position: relative;">
			<div v-if="listData.undraggable" class="icon-suoding icon iconfont"></div>
			<div class="border" v-if="listData.type==0" data-is-check="false">
				<div class="uploader1">
					<img v-if="listData.detail.imageUrl0" :src="listData.detail.imageUrl0">
					<img v-else="!listData.detail.imageUrl0" src="../assets/picture1.jpg">
				</div>
			</div>
			<div v-if="listData.type==1" style="display: flex;" data-is-check="false" class="uploader1 border">
				<div class="uploader2 " style="">
					<img v-if="listData.detail.imageUrl0" :src="listData.detail.imageUrl0">
					<img v-else="!listData.detail.imageUrl0" src="../assets/picture2.jpg">
				</div>
				<div class="uploader2" style="left:50%">
					<img v-if="listData.detail.imageUrl1" :src="listData.detail.imageUrl1">
					<img v-else src="../assets/picture2.jpg">
				</div>
			</div>
			<div class="video border" v-if="listData.type==2" data-is-check="false">
				<img v-if="listData.detail.imageUrl0" :src="listData.detail.imageUrl0">
			<img v-else src="../assets/picture1.jpg">
				<div class="vedio-border">
					<div class="player icon-video icon iconfont"></div>
				</div>
			</div>
			<div class="form-contain border" v-if="listData.type==3" data-is-check="false">
				<img v-if="listData.detail.imageUrl0" :src="listData.detail.imageUrl0">
				<img v-else src="../assets/picture3.jpg">
				<div class="form" :style="'top:'+listData.detail.position+'%'"><input type="number" class="input" />
					<div class="btn border">
						<img v-if="listData.detail.imageUrl1" :src="listData.detail.imageUrl1">

					</div>
				</div>
			</div>
			<!--						:style="{top: hotItem.x + 'px',left: hotItem.y + 'px',width: hotItem.w + 'px',height: hotItem.h + 'px',zIndex: 2}"-->
			<VueDraggableResizable style="display: flex;color: #fff;justify-content: center;    align-items: center;" v-if="listData.type==0||1" :ref="'dragResize'+hotIndex+index" :is-conflict-check="true" :snap="true" :parent="true" @dragEnd="resizeStop" :key="hotIndex" :resizeIndex="hotIndex" v-for="(hotItem,hotIndex) in listData.hotData" :x="hotItem.x" :y="hotItem.y" :w="hotItem.w" :h="hotItem.h">
					{{index}}-{{hotIndex}}
			</VueDraggableResizable>
		</div>

	</div>
</template>
<script>
	import '../assets/iconfont.css';
	import VueDraggableResizable from '../components/vue-draggable-resizable.vue'
	// 引入拖拽组件
	export default {
		name: 'PostElement',
		props: {
			listData: [Object],
			index: [Number],
			isDrag: [Boolean]

		},
		components: {
			VueDraggableResizable
		},
		data() {
			return {
				imageUrl: "",
				hotData: []
			}
		},
		methods: {

			resizeStop(e, x, y, w, h) {

				this.$emit('resizeStop', this.index, e, x, y, w, h)
			},
			chooseDrag(index) {
				this.$emit('chooseDrag', this, this.index)
			}

		},

		watch: {
			'listData.hotData': {

				handler(data, data1) {
					var that = this;
					this.$nextTick(() => {
						that.listData.hotData && that.listData.hotData.map((item, index) => {
							if(that.$refs) {
								that.$refs['dragResize' + index + that.index] && that.$refs['dragResize' + index + that.index][0].changeData(item.x, item.y, item.w, item.h)
							}
						})
					})

					return data
				},
				deep: true //对象内部属性的监听，关键。
			},
		}
	}
</script>

<style scoped lang="less">
	.uploader1 {
		width: 100%;
		display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
		position: relative;
		img {
			left: 0;
			top: 0;
			width: 100%;
			display: block;
		}
	}
	
	.vedio-border {
		width: 90%;
		height: 100%;
		left: 5%;
		top: 0%;
		position: absolute;
	}
	
	.uploader2 {
		width: 50%;
		height: 100%;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		/* text-align: center; */
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	
	.border {
		    box-sizing: border-box;
		border: 2px solid #d9d9d9;
		&:hover {
			border-color: #409EFF;
		}
	}
	
	.video {
		margin: 0px auto;
		position: relative;
		width: 100%;
		clear: both;
		img {
			width: 100%;
			display: block;
		}
	}
	
	.form-contain {
		position: relative;
		width: 100%;
		img {
			width: 100%;
			display: block;
		}
	}
	
	.player {
		z-index: 1;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		font-size: 120px;
		justify-content: center;
		align-items: center;
		color: #d9d9d9;
		background: #000;
	}
	
	.form {
		position: absolute;
		top: 0;
		left: 5%;
		height: 100%;
		width: 90%;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.input {
			height: 32px;
		}
		.btn {
			width: 80px;
			min-height: 32px;
		}
	}
	
	.draggable {
		border: 1px dashed lightcoral;
		pointer-events: fill;
		z-index: 20!important
	}
	
	.content {
		padding: 30px;
		padding-top: 0;
	}
	
	.icon-suoding {
		position: absolute;
		right: -16px;
		color: red;
		font-size: 36px;
		    z-index: 10;
	}
	
	/deep/ textarea {
		width: 254px;
		height: 64px
	}
	
	/deep/ input {
		width: 178px;
		height: 27px;
	}
	/deep/ .draggable{
		    background: rgb(206, 0, 10);
    opacity: 0.6;
	}
</style>


// WEBPACK FOOTER //
// src/components/PostElement.vue